export function applyAction(state, targetKey, action) {
  const fieldState = state[targetKey];
  if (!fieldState) return;

  switch (action.action) {
    case 'show':
      fieldState.visible = true;
      break;

    case 'hide':
      fieldState.visible = false;
      break;

    case 'enable':
      fieldState.disabled = false;
      break;

    case 'disable':
      fieldState.disabled = true;
      break;

    case 'setRequired':
      fieldState.required = action.value !== false;
      break;

    case 'clearRequired':
      fieldState.required = false;
      break;

    case 'setValue':
      fieldState.forcedValue = action.value;
      break;

    default:
      console.warn(`[FieldEngine] Unknown effect action: "${action.action}" on field "${targetKey}"`);
  }
}
